// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyAsPUbL0COz7vFzVPCYC3RZA3zdgtF3Guk",
  authDomain: "win-wininternationalforum.firebaseapp.com",
  projectId: "win-wininternationalforum",
  storageBucket: "win-wininternationalforum.appspot.com",
  messagingSenderId: "825080859416",
  appId: "1:825080859416:web:7dc15b7cb18bc6e8d76c6d",
  measurementId: "G-RD3CYYFNXS"
};

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/win-wininternationalforum.appspot.com/o/'